import { useTreeViewForFinalOutput } from "@/components/table-preview/sidebar/hook";
import { Fragment } from "react";
import { useParams } from "react-router-dom";
import StructureTable from "./structure/structure-table";
import StructureTree from "./structure/structure-tree";

const StructureContent = ({ tableId }: { tableId: string }) => {
  const { workbookId } = useParams();
  // StructureContent에서만 테이블 태그 변환 적용
  const { treeView: tableTreeView, isLoading } = useTreeViewForFinalOutput(
    workbookId || null,
    tableId || null,
  );

  if (isLoading) return <span className="loading-spinner" />;

  const preRole = tableTreeView?.preRole;

  return (
    <div className="flex flex-col items-start gap-5 self-stretch w-full mt-5">
      {tableTreeView?.treeView.blockItems &&
        tableTreeView?.treeView.blockItems
          .map((item) => item.tags)
          .some((tags) => tags.length > 0) && (
          <StructureTree
            items={tableTreeView?.treeView.blockItems || []}
            dimension="TEXTBLOCK"
          />
        )}
      {tableTreeView?.treeView.current.tables.map((table) => (
        <Fragment key={table.id}>
          <StructureTable table={table} preRole={preRole} />
          <StructureTree items={table.lineItem} dimension="LINE_ITEM" />
          <StructureTree items={table.axis} dimension="AXIS" />
        </Fragment>
      ))}
    </div>
  );
};

export default StructureContent;
